import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Sidebar } from "@/components/Sidebar";
import { Header } from "@/components/Header";
import { QuickAddDialog } from "@/components/QuickAddDialog";
import { ReminderTicket } from "@/components/ticket/ReminderTicket";

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen">
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r bg-[#0d1320]/80 lg:block">
        <Sidebar />
      </aside>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-72 bg-[#0d1320] p-0">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="lg:pl-64">
        <Header onMenu={() => setMobileOpen(true)} />
        <main className="mx-auto max-w-[1400px] px-5 pb-20 pt-8 sm:px-8 lg:px-10">
          <Outlet />
        </main>
      </div>
      <QuickAddDialog />
      <ReminderTicket />
    </div>
  );
}
